<template>
  <div class="base-chart">
    <highcharts
      ref="chart"
      class="_chart"
      :options="optionsWithDefaults"
      :update-args="updateArgs"
    />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';

const reflowCallbacks = new WeakMap();
let sharedObserver = null;
const getSharedObserver = () => {
  if (sharedObserver === null) {
    sharedObserver = new ResizeObserver((entries) => {
      for (let i = 0; i < entries.length; i += 1) {
        const cb = reflowCallbacks.get(entries[i].target);
        if (cb) cb();
      }
    });
  }
  return sharedObserver;
};

export default {
  name: 'BaseChart',
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  components: { highcharts: Chart },
  data() {
    return { updateArgs: [true, true, false] };
  },
  computed: {
    optionsWithDefaults() {
      return {
        chart: {
          height: 250,
          marginBottom: 22,
          marginRight: 8,
        },
        ...this.options,
      };
    },
  },
  mounted() {
    const el = this.$refs.chart.$el;
    this._observedEl = el;
    reflowCallbacks.set(el, () => this.$refs.chart?.chart?.reflow());
    getSharedObserver().observe(el);
  },
  unmounted() {
    if (this._observedEl) {
      getSharedObserver().unobserve(this._observedEl);
      reflowCallbacks.delete(this._observedEl);
      this._observedEl = null;
    }
  },
};
</script>

<style lang="scss" type="text/scss">
  .base-chart {
    ._chart {
      overflow: visible !important;

      .highcharts-container {
        overflow: visible !important;

        svg {
          overflow: visible !important;
        }
      }
    }
  }
</style>
